<mat-calendar #calendar [minDate]="calMinDate" [maxDate]="calMaxDate" [startAt]="startDate"
    [headerComponent]="datePickerHeader" [dateClass]="dateClass" [(selected)]="selectedDate"
    (selectedChange)="dateChanged()" (keydown)="hideErrorMessage($event)" (keyup)="handleNav($event)">
</mat-calendar>
